<template>
  <a-breadcrumb>
    <a-breadcrumb-item>
      <router-link to="/">
        <a-icon type="home" />
      </router-link>
    </a-breadcrumb-item>
    <a-breadcrumb-item v-for="(item, index) in breadList" :key="index">
      <router-link :to="{ name: item.routeName }">
        {{ $t(item.i18nName) }}
      </router-link>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import { routerMap } from '@GM/Layout/routerMap'
import { getObjectKey } from '@GUTIL/other'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      breadList: []
    }
  },
  computed: {
    ...mapGetters(['folderName']),
    currentRouterMap() {
      return routerMap[this.folderName]
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      this.breadList = []
      let lastMatchedName = this.$route.name
      let currentRouteKey = getObjectKey(this.currentRouterMap, lastMatchedName)
      if (!currentRouteKey) {
        return
      }

      let routeKey = '',
        i18nKey = ''
      // KO2.1.1 => [KO2, 1, 1]
      currentRouteKey.split('.').forEach((str, idx) => {
        routeKey =
          idx == 0 ? routeKey.concat(`${str}`) : routeKey.concat(`.${str}`)
        i18nKey =
          idx == 0 ? i18nKey.concat(`${str}`) : i18nKey.concat(`_${str}`)

        if (typeof this.currentRouterMap[routeKey] !== 'undefined') {
          this.breadList.push({
            i18nName:
              routeKey == 'Home' ? `i18n_home` : `i18n_route_${i18nKey}`,
            routeName: this.currentRouterMap[routeKey]
          })
        }
      })
    },
    dotToUnderline(text) {
      return text.replace(/\./g, '_')
    }
  }
}
</script>
